import $api from "@/frontend/shared/api/axios";

type TUpdateDetailsProps = {
  firstName: string;
  lastName: string;
  email: string;
  bio: string;
  profileImageUrl: string | null;
};

export async function patchUpdateDetails({ firstName, lastName, email, bio, profileImageUrl }: TUpdateDetailsProps) {
  const response = await $api.patch("/me", { firstName, lastName, email, bio, profileImageUrl });
  return response.data;
}
